export const MOBILE_BREAKPOINT_PX = 900;

export const breakpoints = {
    mediumMin: `min-width: ${MOBILE_BREAKPOINT_PX}px`,
    mediumMinHeight: 'min-height: 800px',
    smallMaxHeight: 'max-height: 580px',
};
